import _ from 'lodash';
import { FeaturePermission } from '../../../../constants/feature.permission.helper';
import environment from '../../../../scripts/environment';
import translate from '../../../../scripts/core/tools/translate';
import api from '../../../../scripts/api';
const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);


export class CustomersAfterSalesFactory {
    constructor({options, currentMap}){
        this.options = options;
        this.currentMap = currentMap;
    }

    getData() {
        // const states = environment.get('CONFIG.FILTERS.CUSTOMERS_STATE_ACRONYMS');
        const salesCustomerTypes = environment.get('CONFIG.FILTERS.SALES_CUSTOMER_TYPES');

        // const statesSource = [
        //     {
        //         name: 'state_acronym',
        //         position: 1,
        //         data: states,
        //         fields: [
        //             {
        //                 title: translate('Common.State'),
        //                 name: 'stateAcronym',
        //                 value: 'nome',
        //                 text: 'nome',
        //                 type: 'dropdown',
        //                 orderBy: "nome",
        //                 required: true,
        //             },
        //         ]
        //     }
        // ];


        let customersTypesSource = [
            {
                name: 'sales_customers_types',
                position: 2,
                data: salesCustomerTypes,
                fields: [
                    {
                        title: translate('Common.CustomerType'),
                        name: 'salesCustomerTypes',
                        value: 'id',
                        text: 'nome',
                        type: 'multiselect',
                        orderBy: "nome"
                    },
                ]
            }
        ];

        if (isAuthorized(FeaturePermission.LAYER_AFTER_SALES_NETWORK.changeTitleOfChartsAndFilters)) {
            customersTypesSource = [];
            customersTypesSource.push({
                name: 'salesTypes',
                position: 1,
                data: salesCustomerTypes,
                fields: [
                    {
                        title: translate('Common.TypeSegmentMarket'),
                        name: 'salesTypes',
                        value: 'id',
                        text: 'nome',
                        type: 'multiselect',
                        skipAll: true
                    }
                ]
            });
        }

        // let data = [...statesSource, ...customersTypesSource];
        let data = [...customersTypesSource];

        return data;
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/customersAfterSales.js